import React from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import useAuthUser from "../components/useAuthUser"; // Make sure you created this hook
import { User } from "lucide-react";

export default function AccountPage({ themeKey, themes }) {
  const user = useAuthUser();
  const navigate = useNavigate();
  const theme = themes?.[themeKey] || {
    colors: { background: "#23252b", text: "#fff", logoBackground: "#444", logoText: "#fff" },
    fontFamily: "monospace"
  };

  // If not logged in, redirect to login
  React.useEffect(() => {
    if (user === null) navigate("/login");
  }, [user, navigate]);

  if (!user) return null; // Or a loading spinner

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center"
      style={{
        background: theme.colors.background,
        color: theme.colors.text,
        fontFamily: theme.fontFamily || "monospace",
      }}
    >
      <div
        className="rounded-2xl p-10 shadow-lg flex flex-col items-center gap-4 w-full max-w-md"
        style={{
          background: theme.colors.logoBackground,
          color: theme.colors.logoText,
        }}
      >
        <div className="flex items-center gap-3 mb-2">
          <User size={38} />
          <div>
            <div className="text-2xl font-bold tracking-tight">
              {user.displayName || user.email || "Account"}
            </div>
            <div className="text-sm font-mono opacity-80">
              {user.email}
            </div>
            <div className="text-xs mt-1 opacity-60">{user.uid}</div>
          </div>
        </div>
        <div className="w-full border-t border-zinc-500 my-3" />
        <button
          className="px-4 py-2 rounded-lg font-semibold mt-4 bg-red-500 hover:bg-red-600 transition text-white"
          onClick={async () => {
            await signOut(auth);
            navigate("/login");
          }}
        >
          Sign Out
        </button>
        <button
          className="px-4 py-2 rounded-lg font-semibold mt-2 bg-gray-600 hover:bg-gray-700 transition text-white"
          onClick={() => navigate("/")}
        >
          ← Back to Home
        </button>
      </div>
    </div>
  );
}
